import React, { useState } from "react";
import ProfitAndLossStatement from "./ProfitAndLossStatement";
import DateRange from "../DateRange";
import useAuthStore from "../../../../store/useAuthStore";
import { SlidingCubeLoader } from "react-loaders-kit";

const ParentComponent = () => {
  const [ComparisonData, setComparisonData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [initialized, setInitialized] = useState(false);
  const { token } = useAuthStore();

  const handleFilteredDataChange = async ({ ranges }) => {
    setLoading(true);
    setInitialized(true);
    try {
      const fetchOptions = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const comparisonData = await Promise.all(
        ranges.map(async (range) => {
          const startDate = range.startDate.toISOString().split("T")[0];
          const endDate = range.endDate.toISOString().split("T")[0];

          const incomeResponse = await fetch(
            `/api/getallIncomes?startDate=${startDate}&endDate=${endDate}&limit=-1`,
            fetchOptions
          );
          const expenseResponse = await fetch(
            `/api/getallexpense?startDate=${startDate}&endDate=${endDate}&limit=-1`,
            fetchOptions
          );

          if (!incomeResponse.ok || !expenseResponse.ok) {
            throw new Error("Failed to fetch data");
          }

          const incomeResult = await incomeResponse.json();
          const expenseResult = await expenseResponse.json();

          const incomes = incomeResult.incomes || [];
          const expenses = expenseResult.expenses || [];

          const periodData = [
            ...incomes.map((income) => ({
              ...income,
              type: "income",
            })),
            ...expenses.map((expense) => ({
              ...expense,
              type: "expense",
            })),
          ];

          return {
            period: [range.startDate, range.endDate],
            data: periodData,
          };
        })
      );

      setComparisonData(comparisonData);
      setError("");
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Error updating report data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (error) {
    return <div className="text-center text-red-500">{error}</div>;
  }

  return (
    <div>
      <DateRange
        onFilteredDataChange={handleFilteredDataChange}
      // setLoading={setLoading}
      // loading={loading}
      />
      {loading || !initialized ? (
        <div className="flex justify-center items-center min-h-[400px]">
          <SlidingCubeLoader
            loading={true}
            size={50}
            colors={["#2887D4BE", "#0976C3BE"]}
            duration={1}
          />
        </div>
      ) : (
        <ProfitAndLossStatement comparisonData={ComparisonData} />
      )}
    </div>
  );
};

export default ParentComponent;
